/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Generic_Linking_ErrorInputs */

const en_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whoops! Something went wrong with linking your account. Please contact Brave support.`)
};

const id_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aduh! Ada yang salah dalam menghubungkan akun Anda. Silakan hubungi dukungan Brave.`)
};

const ms_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wah-oh! Sesuatu yang tidak kena dengan pautan akaun anda. Sila hubungi sokongan Brave.`)
};

const ca_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaja! Hi ha hagut un problema en enllaçar el teu compte. Si us plau, contacta amb el suport tècnic de Brave.`)
};

const cs_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jejda! Při propojování vašeho účtu došlo k chybě. Kontaktujte podporu Brave.`)
};

const da_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hovsa! Noget gik galt, da vi ville forbinde din konto. Kontakt venligst Brave support.`)
};

const de_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upps! Beim Verknüpfen Ihres Kontos ist etwas schiefgelaufen. Bitte kontaktieren Sie den Brave-Support.`)
};

const et_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oih! Konto linkimisel ilmnes tõrge. Võtke ühendust Brave toe teenusega.`)
};

const es_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Ups! Algo salió mal al vincular tu cuenta. Por favor, ponte en contacto con el soporte de Brave.`)
};

const fr_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de lier votre compte. Veuillez contacter l’assistance Brave.`)
};

const hr_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups! Došlo je do problema s povezivanjem vašeg računa. Molimo obratite se Brave podršci.`)
};

const it_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ops! Si è verificato un problema durante il collegamento del tuo account. Contatta il supporto Brave.`)
};

const lv_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups! Kaut kas nogāja greizi, sasaistot jūsu kontu. Lūdzu, sazinieties ar Brave atbalstu.`)
};

const lt_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oi! Kažkas nutiko ne taip susiejant jūsų paskyrą. Kreipkitės į Brave palaikymą.`)
};

const hu_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoppá! Valami hiba történt a fiók összekapcsolásával. Kérjük, vegye fel a kapcsolatot a Brave támogatással.`)
};

const nl_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oeps! Er ging iets mis met het koppelen van je account. Neem contact op met Brave support.`)
};

const nb_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oi! Vi kunne ikke koble til kontoen din. Ta kontakt med Braves brukerstøtte for å få hjelp.`)
};

const pl_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups! Coś poszło nie tak podczas łączenia twojego konta. Skontaktuj się z pomocą techniczną Brave.`)
};

const pt_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ops! Algo deu errado ao vincular sua conta. Por favor, contate o suporte do Brave.`)
};

const ro_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hopa! A apărut o problemă la legarea contului dvs. Vă rugăm să contactați asistența Brave.`)
};

const sk_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups! Niečo sa pokazilo pri prepojení vášho účtu. Kontaktujte prosím podporu Brave.`)
};

const sl_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups! Prišlo je do napake pri povezovanju vašega računa. Prosimo, obrnite se na podporo Brave.`)
};

const fi_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hups! Tapahtui virhe tilisi linkittämisessä. Ota yhteyttä Brave-tukeen.`)
};

const sv_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoppsan! Något gick fel vid länkningen av ditt konto. Vänligen kontakta Brave-support.`)
};

const vi_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ối! Đã xảy ra sự cố khi liên kết tài khoản của bạn. Vui lòng liên hệ hỗ trợ Brave.`)
};

const tr_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüh! Hesabınızı bağlarken bir şeyler ters gitti. Lütfen Brave destek ile iletişime geçin.`)
};

const el_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ορίστε! Κάτι πήγε στραβά με τη σύνδεση του λογαριασμού σας. Παρακαλούμε επικοινωνήστε με την υποστήριξη του Brave.`)
};

const bg_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упс! Нещо се обърка при свързването на вашия акаунт. Моля, свържете се с поддръжка на Brave.`)
};

const ru_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упс! Что-то пошло не так при связывании вашего аккаунта. Пожалуйста, свяжитесь с поддержкой Brave.`)
};

const sr_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упс! Дошло је до проблема приликом повезивања вашег налога. Молимо контактирајте Brave подршку.`)
};

const uk_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упс! Щось пішло не так під час пов'язування вашого облікового запису. Будь ласка, зверніться до служби підтримки Brave.`)
};

const ka_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ვერა! რაღაც შეცდომა მოხდა თქვენი ანგარიშის დაკავშირებაში. გთხოვთ დაუკავშირდეთ Brave-ის მხარდაჭერას.`)
};

const hi_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्षमा करें! आपके खाते को लिंक करते समय कुछ गलत हो गया। कृपया Brave सपोर्ट से संपर्क करें।`)
};

const th_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อุ๊ปส์! เกิดข้อผิดพลาดในการเชื่อมโยงบัญชีของคุณ โปรดติดต่อฝ่ายสนับสนุนของ Brave`)
};

const ko_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`죄송합니다! 계정 연결 중 문제가 발생했습니다. Brave 지원에 문의해 주세요.`)
};

const zh_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`糟糕！链接您的账户时出错了。请联系 Brave 支持。`)
};

const zh_tw_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哎呀！連結您的帳戶時發生了問題。請聯絡 Brave 支援團隊。`)
};

const ja_generic_linking_error = /** @type {(inputs: Generic_Linking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申し訳ありませんが、アカウントのリンク中にエラーが発生しました。Braveサポートまでお問い合わせください。`)
};

/**
* | output |
* | --- |
* | "Whoops! Something went wrong with linking your account. Please contact Brave support." |
*
* @param {Generic_Linking_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const generic_linking_error = /** @type {((inputs?: Generic_Linking_ErrorInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Generic_Linking_ErrorInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_generic_linking_error(inputs)
	if (locale === "ms") return ms_generic_linking_error(inputs)
	if (locale === "ca") return ca_generic_linking_error(inputs)
	if (locale === "cs") return cs_generic_linking_error(inputs)
	if (locale === "da") return da_generic_linking_error(inputs)
	if (locale === "de") return de_generic_linking_error(inputs)
	if (locale === "et") return et_generic_linking_error(inputs)
	if (locale === "es") return es_generic_linking_error(inputs)
	if (locale === "fr") return fr_generic_linking_error(inputs)
	if (locale === "hr") return hr_generic_linking_error(inputs)
	if (locale === "it") return it_generic_linking_error(inputs)
	if (locale === "lv") return lv_generic_linking_error(inputs)
	if (locale === "lt") return lt_generic_linking_error(inputs)
	if (locale === "hu") return hu_generic_linking_error(inputs)
	if (locale === "nl") return nl_generic_linking_error(inputs)
	if (locale === "nb") return nb_generic_linking_error(inputs)
	if (locale === "pl") return pl_generic_linking_error(inputs)
	if (locale === "pt") return pt_generic_linking_error(inputs)
	if (locale === "ro") return ro_generic_linking_error(inputs)
	if (locale === "sk") return sk_generic_linking_error(inputs)
	if (locale === "sl") return sl_generic_linking_error(inputs)
	if (locale === "fi") return fi_generic_linking_error(inputs)
	if (locale === "sv") return sv_generic_linking_error(inputs)
	if (locale === "vi") return vi_generic_linking_error(inputs)
	if (locale === "tr") return tr_generic_linking_error(inputs)
	if (locale === "el") return el_generic_linking_error(inputs)
	if (locale === "bg") return bg_generic_linking_error(inputs)
	if (locale === "ru") return ru_generic_linking_error(inputs)
	if (locale === "sr") return sr_generic_linking_error(inputs)
	if (locale === "uk") return uk_generic_linking_error(inputs)
	if (locale === "ka") return ka_generic_linking_error(inputs)
	if (locale === "hi") return hi_generic_linking_error(inputs)
	if (locale === "th") return th_generic_linking_error(inputs)
	if (locale === "ko") return ko_generic_linking_error(inputs)
	if (locale === "zh") return zh_generic_linking_error(inputs)
	if (locale === "zh-tw") return zh_tw_generic_linking_error(inputs)
	if (locale === "ja") return ja_generic_linking_error(inputs)
	return en_generic_linking_error(inputs)
});